import FullArticle from "./FullArticle";
export default FullArticle;